var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    class: ['capsule-article', ("capsule-article--" + _vm.propId), _vm.isInViewport && !_vm.getRouteLeave ? 'capsule-article--appear' : '', _vm.choiced ? 'capsule-article--choiced' : ''],
    style: ({
      transitionDuration: (_vm.transitionDuration + "s"),
      transitionDelay: (_vm.transitionDelay + "s")
    })
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.contentData.slug))
    },
    nativeOn: {
      "click": function($event) {
        _vm.isChoiced($event)
      }
    }
  }, [_c('div', {
    staticClass: "capsule-article__img-container"
  }, [_c('div', {
    ref: "scene",
    staticClass: "capsule-article__scene"
  }, [_c('vue-img-loader', {
    attrs: {
      "data-depth": ".2",
      "preview": _vm.contentData.acf.main_picture_project.sizes.medium,
      "src": _vm.contentData.acf.main_picture_project.url,
      "transition": "fadeIn",
      "blur-preview": false
    }
  }, [_c('div', {
    staticClass: "capsule-article__spinner-container",
    attrs: {
      "data-depth": "0"
    }
  }, [_c('div', {
    staticClass: "capsule-article__spinner"
  })])])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "capsule-article__title-container",
    style: ({
      transitionDuration: (_vm.transitionDuration + "s"),
      transitionDelay: (_vm.transitionDelay + "s")
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.contentData.title.rendered))]), _vm._v(" "), (_vm.contentData.acf.customer_project) ? _c('span', {
    staticClass: "capsule-article__customer"
  }, [_vm._v(_vm._s(_vm.contentData.acf.customer_project))]) : _vm._e()])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34e18cb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/common/article/Capsule.vue
// module id = Gyfz
// module chunks = 1